import { DigitalAgent as ApiDigitalAgent } from '@vendasta/task-manager';

export interface DigitalAgentInterface {
  subjectId: string;
  userId: string;
  partnerId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  accessiblePartnerIds: string[];
  partnerPermissions?: { [key: string]: PartnerPermissions };
}

export interface ApiAgent {
  digital_agent_id: string;
  _user_id: string;
  partner_id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  partner_permissions: {
    [key: string]: {
      // do nothing.
    };
  };
  _accessible_partner_ids: string[];
}

export class DigitalAgent implements DigitalAgentInterface {
  subjectId: string;
  userId: string;
  partnerId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  accessiblePartnerIds: string[];
  partnerPermissions: { [key: string]: PartnerPermissions };
  constructor(agent: DigitalAgentInterface) {
    this.subjectId = agent.subjectId;
    this.userId = agent.userId;
    this.partnerId = agent.partnerId;
    this.email = agent.email;
    this.firstName = agent.firstName;
    this.lastName = agent.lastName;
    this.accessiblePartnerIds = agent.accessiblePartnerIds;
    if (agent.partnerPermissions != null && Object.keys(agent.partnerPermissions).length > 0) {
      this.partnerPermissions = agent.partnerPermissions;
    } else {
      this.partnerPermissions = { [agent.partnerId]: {} };
    }
  }

  static fromApi(agent: ApiDigitalAgent): DigitalAgent {
    const partnerPermissions: { [partnerId: string]: PartnerPermissions } = {};
    for (const partnerId in agent.partnerPermissions) {
      const apiPermissions = agent.partnerPermissions[partnerId];
      if (apiPermissions) {
        partnerPermissions[partnerId] = {
          can_access: apiPermissions.canAccess,
          can_delete_tasks: apiPermissions.isManager,
        };
      }
    }
    return new DigitalAgent({
      subjectId: agent.subjectId,
      userId: agent.userId,
      partnerId: agent.partnerId,
      email: agent.email,
      firstName: agent.firstName,
      lastName: agent.lastName,
      partnerPermissions: partnerPermissions,
      accessiblePartnerIds: agent.accessiblePartnerIds,
    });
  }
}

export interface PartnerPermissions {
  can_access?: boolean;
  can_delete_tasks?: boolean;
}
